export const facebookButtonTemplate = (ctx: any) => {
  return `<a href="#" class="fb-btn">
            <div class="fb-icon"></div>
            <div class="fb-text">${ctx.info.component.label}</div>
          </a>`;
};
